// test1218
(1218 && 0);
